export const notices = {
    otpRequestOK: {
        text: "We've emailed you a new verification code. It can take up to a few minutes to arrive.",
        name: 'otpRequestOK',
        displaysInline: false,
        isError: false
    },
    tooManyRequests: {
        text: "It looks like you've tried too many times. Try again later, or reset password.",
        name: 'tooManyRequests',
        displaysInline: false,
        isError: true
    },
    wrongCode: {
        text: 'Code is invalid. Please try again.',
        name: 'wrongCode',
        displaysInline: true,
        isError: true
    },
    unknown: {
        text: 'An unknown error has occured. Please try again later.',
        name: 'unknown',
        displaysInline: false,
        isError: true
    },
    login: {
        text: 'Failed to login, please try again.',
        name: 'login',
        displaysInline: false,
        isError: true
    }
};
